import * as React from 'react'
import clx from 'classnames'
import { Checkbox } from '@/ui/form/primitives/checkbox'

/**
 * Pole wyboru z etykietą, oparte o `Checkbox` z designu aplikacji.
 *
 * Zastępuje `CustomInput type="checkbox"` z reactstrapa w panelu admina - API jest
 * to samo (`id`, `label`, `checked`, `onChange`, `disabled`), więc wywołania się nie
 * zmieniają, zmienia się tylko wygląd: 16 px kwadrat z designu zamiast 22 px SVG
 * z bootstrapowego `custom-control`.
 */
type CheckboxFieldProps = {
  id: string
  label?: React.ReactNode
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  className?: string
  style?: React.CSSProperties
}

export const CheckboxField = ({
  id,
  label,
  checked = false,
  onChange,
  disabled = false,
  className,
  style,
}: CheckboxFieldProps) => (
  <div
    className={clx('tw-inline-flex tw-items-center tw-gap-2', className)}
    style={style}
  >
    <Checkbox
      id={id}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
    {label ? (
      <label
        htmlFor={id}
        className={clx('tw-mb-0 tw-select-none tw-text-sm', {
          'tw-cursor-pointer': !disabled,
          'tw-cursor-not-allowed tw-opacity-70': disabled,
        })}
      >
        {label}
      </label>
    ) : null}
  </div>
)
